import { classNames } from "@ember-decorators/component";
import icon from "discourse/helpers/d-icon";
import ComboBoxSelectBoxHeaderComponent from "select-kit/components/combo-box/combo-box-header";
import { resolveComponent } from "select-kit/components/select-kit";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const TagDropHeader = dt7948.c(class TagDropHeader extends ComboBoxSelectBoxHeaderComponent {
  static {
    setComponentTemplate(precompileTemplate("\n    <div class=\"select-kit-header-wrapper\">\n      {{#let (resolveComponent this this.selectKit.options.selectedNameComponent) as |SelectedNameComponent|}}\n        <SelectedNameComponent @tabindex={{this.tabindex}} @item={{this.selectedContent}} @selectKit={{this.selectKit}} @shouldDisplayClearableButton={{this.shouldDisplayClearableButton}} />\n      {{/let}}\n\n      {{icon this.caretIcon class=\"caret-icon\"}}\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        resolveComponent,
        icon
      })
    }), this);
  }
}, [classNames("tag-drop-header")]);
export default TagDropHeader;